import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import { Grid, Snackbar, Alert as MuiAlert, Autocomplete } from '@mui/material'
import { JsonFormsDispatch } from '@jsonforms/react';
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {
  materialRenderers,
  materialCells,
} from '@jsonforms/material-renderers';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
// Redundant import removed
import TextField from "@mui/material/TextField";
import { JsonForms } from '@jsonforms/react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { SvgIcon, CircularProgress } from '@mui/material';
import FileWidget from './FileWidget'
import { download_zip_file } from '../../../store/job/jobSlice';
import { useNavigate } from 'react-router-dom'
import { setPrevStage, setNewStage, clearJobData, get_sidebar_menu } from '../../../store/job/jobSlice'
import { useDispatch, useSelector } from 'react-redux'
import { rankWith, isControl, uiTypeIs, optionIs, and, scopeEndsWith } from '@jsonforms/core';
import { withJsonFormsLayoutProps, withJsonFormsControlProps, useJsonForms } from '@jsonforms/react';
import { setCompany, setProcessTab, setProcessHasJobForm, get_company_process, get_company_process_stage, setStageTab, get_users_rep_dropdown, setCommonLoading } from '../../../store/user/userSlice';
import { isAuth } from '../../../helpers/cookies';
import { 
  SUPER_ADMIN, 
  COMPANY_USER, 
  COMPANY_MANAGER, 
  ADDNECTAR_ARTIST, 
  ADDNECTAR_MANAGER,
  ADMIN,
  ADDNECTAR_ADMIN,
  ADDNECTAR_ACCOUNT_MANAGER
} from '../../../helpers/constants';
import { debounce } from "lodash";
import { formatDateTime } from '../../../helpers/cookies';
import { grey } from "@mui/material/colors";
import Tooltip from "@mui/material/Tooltip";
import PdfThumbnail from './PdfThumbnail';
import AddIcon from '@mui/icons-material/Add';
import { AddLink } from '@mui/icons-material';
import AddLinkIcon from '@mui/icons-material/AddLink';
import BrandLibraryModal from './BrandLibraryModal';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment from '@mui/material/InputAdornment';
import JobItemsTableRenderer from './JobItemsTableRenderer';
import { update_correction, clearPendingCorrectionIds, add_correction, clearPendingCorrection } from '../../../store/job/jobSlice';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const LibraryAddSvgIcon = (props) => (
  <SvgIcon {...props}>
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 2h11a2 2 0 0 1 2 2v11" />
      <path d="M2 4h11a2 2 0 0 1 2 2v11" />
      <path d="M0 6h11a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" fill="white" />
      <circle cx="16" cy="16" r="6" fill="white" />
      <path d="M16 13v6" />
      <path d="M13 16h6" />
    </g>
  </SvgIcon>
);

const DeleteSvgIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2m-6 5v6m4-6v6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

const theme = createTheme({
  components: {
    MuiInputBase: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: "#000000",
            WebkitTextFillColor: "#000000 !important",
            opacity: 1
          }
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
          backgroundColor: 'white',
          padding: '0 4px',
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '20px',
          width: '100%'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BDBDBD"
          }
        },
        input: {
          "&.Mui-disabled": {
            color: "#000000 !important",
            WebkitTextFillColor: "#000000 !important",
            opacity: 1
          }
        }
      }
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small'
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            marginLeft: '1rem',
            marginRight: 0,
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '20px'
        }
      }
    }
  },
});

const SubmittedDateLabelRenderer = ({ uischema, data }) => {
  const { text, scope } = uischema;
  const path = scope?.replace("#/properties/", "");
  const value = data?.[path] || "";

  return (
    <TextField
      label={text || uischema.label}
      value={value ? formatDateTime(value) : ""}
      fullWidth
      variant="outlined"
      size="small"
      InputProps={{
        readOnly: true,
      }}
      sx={{ mb: 2.5 }}
    />
  );
};

const CompletedDateLabelRenderer = ({ uischema, data }) => {
  const { text, scope } = uischema;
  const path = scope?.replace("#/properties/", "");
  const value = data?.[path] ? formatDateTime(data[path]) : "";

  return (
    <TextField
      label={text || uischema.label}
      value={value}
      fullWidth
      variant="outlined"
      size="small"
      InputProps={{
        readOnly: true,
      }}
      sx={{ mb: 2.5 }}
    />
  );
};

const ReadOnlyGreyRenderer = ({ uischema, data, label, path }) => {
  let value = data || "";
  if (path === "virtual_request" && value === "Req") {
    value = "New";
  }
  return (
    <TextField
      label={label || uischema.label}
      value={value}
      fullWidth
      variant="outlined"
      size="small"
      disabled={true}
      sx={{ 
        mb: 2.5,
        "& .MuiInputBase-root.Mui-disabled": {
          bgcolor: "#f5f5f5", // light grey
        }
      }}
    />
  );
};

const BorderedBooleanRenderer = ({ data, handleChange, path, uischema, enabled }) => {
  const { label } = uischema;
  const value = data || false;


  return (
    <Box
      sx={{
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        padding: "8.5px 14px",
        display: "flex",
        alignItems: "center",
        mb: 2.5,
        cursor: enabled ? 'pointer' : 'default',
        opacity: enabled ? 1 : 0.7,
        bgcolor: enabled ? 'transparent' : '#f5f5f5',
        '&:hover': {
          border: enabled ? '1px solid rgba(0, 0, 0, 0.87)' : '1px solid rgba(0, 0, 0, 0.23)',
        }
      }}
      onClick={() => {
        if (!enabled) return;
        handleChange(path, !value);
      }}
    >
      <input
        type="checkbox"
        checked={value}
        disabled={!enabled}
        onChange={(e) => {
          if (!enabled) return;
          handleChange(path, e.target.checked);
        }}
        style={{
          width: "18px",
          height: "18px",
          marginRight: "10px",
          accentColor: "#ff6100",
          cursor: enabled ? "pointer" : "default",
        }}
      />
      <Typography sx={{ flexGrow: 1, color: "text.secondary", fontSize: "1rem" }}>
        {label}
      </Typography>
    </Box>
  );
};

/* ===== STABLE RENDERER FOR DESCRIPTION FIELD ===== */
const DescriptionRenderer = ({ data, handleChange, path, uischema, enabled }) => {
  const value = data || "";
  const baseLabel = uischema.label || "Description";
  // Manually append asterisk to ensure visibility
  const label = baseLabel.includes('*') ? baseLabel : `${baseLabel} *`;

  return (
    <TextField
      label={label}
      placeholder={baseLabel}
      value={value}
      onChange={(e) => handleChange(path, e.target.value)}
      disabled={!enabled}
      multiline
      minRows={4}
      fullWidth
      variant="outlined"
      size="small"
      // PASSING label to OutlinedInput explicitly to ensure notch calculates correctly
      InputProps={{
        label: label
      }}
      sx={{
        mb: 2.5,
        '& .MuiOutlinedInput-root': {
          // Remove fixed height so it can grow
          // height: '108px', 
          alignItems: 'flex-start',
        }
      }}
    />
  );
};

/* ===== CUSTOM RENDERER FOR REFERENCE # FIELD ===== */
const ReferenceRenderer = ({ data, handleChange, path, uischema, enabled }) => {
  const value = data || "";
  return (
    <TextField
      label={uischema.label || "Reference #"}
      value={value}
      onChange={(e) => handleChange(path, e.target.value)}
      disabled={!enabled}
      variant="outlined"
      fullWidth
      size="small"
      InputProps={{
        endAdornment: (value && enabled) ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => handleChange(path, "")}
              edge="end"
              sx={{ p: 0.5 }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      sx={{ mb: 3 }}
    />
  );
};


/* ===== CUSTOM RENDERER FOR REQUEST QUOTE ===== */
const RequestQuoteRenderer = ({ data, handleChange, path, uischema, mode, handleApproveQuote, currentStage, initialRequestQuote, enabled }) => {
  const { label } = uischema;
  const value = data || false;
  const isApproved = currentStage === "Approval Needed";

  return (
    <Box sx={{ mb: 2.5 }}>
      <Box
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          padding: "8.5px 14px",
          display: "flex",
          alignItems: "center",
          cursor: 'pointer',
          '&:hover': {
            border: '1px solid rgba(0, 0, 0, 0.87)',
          }
        }}
        onClick={(e) => {
          if (!enabled) return;
          // Only toggle if the click didn't originate from the input or button
          handleChange(path, !value);
        }}
      >
        <input
          type="checkbox"
          checked={value}
          disabled={!enabled}
          onChange={(e) => {
            if (!enabled) return;
            // The onChange handles the actual value update
            handleChange(path, e.target.checked);
          }}
          onClick={(e) => e.stopPropagation()}
          style={{
            width: "18px",
            height: "18px",
            marginRight: "10px",
            accentColor: "#ff6100",
            cursor: "pointer",
          }}
        />
        <Typography sx={{ flexGrow: 1, color: "text.secondary", fontSize: "1rem" }}>
          {label}
        </Typography>

        {value && mode === 'update' && (
          <Button
            variant="contained"
            size="small"
            disabled={isApproved || !enabled}
            sx={{
              ml: 2,
              backgroundColor: isApproved ? '#4caf50' : '#ff6100',
              color: '#fff',
              textTransform: 'none',
              whiteSpace: "nowrap",
              '&:hover': {
                backgroundColor: isApproved ? '#4caf50' : '#e55600'
              },
              '&.Mui-disabled': {
                backgroundColor: '#a5d6a7',
                color: '#fff'
              }
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (handleApproveQuote) {
                handleApproveQuote(e);
              } else {
              }
            }}
          >
            {isApproved ? "Approved (Click Update)" : "Approve Quote"}
          </Button>
        )}
      </Box>
    </Box>
  );
};

/* ===== CUSTOM RENDERER FOR REP NUMBER DROPDOWN ===== */
const RepNumberRenderer = ({ data, handleChange, path, uischema, enabled }) => {
  const dispatch = useDispatch();
  const company_users = useSelector((state) => state.user.company_users);
  const value = data || "";

  useEffect(() => {
    if (!company_users || company_users.length === 0) {
      dispatch(get_users_rep_dropdown());
    }
  }, [dispatch, company_users]);

  const options = React.useMemo(() => {
    if (!company_users || !Array.isArray(company_users)) {
      return [];
    }

    const mappedOptions = company_users
      .map(u => {
        const repNo = u.rep_number || u.rep_no || u.RepNumber || u.RepNo || "";
        if (!u.first_name && !u.last_name && !repNo) return null;

        return {
          label: `${u.first_name || ''} - ${repNo}`.trim(),
          value: repNo ? String(repNo) : ""
        };
      })
      .filter(item => item !== null);
    return mappedOptions;
  }, [company_users]);

  return (
    <Autocomplete
      options={options}
      disabled={!enabled}
      getOptionLabel={(option) => option.label || ""}
      value={options.find(opt => opt.value === value) || null}
      onChange={(event, newValue) => {
        handleChange(path, newValue ? newValue.value : "");
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={uischema.label || "Rep Number"}
          variant="outlined"
          size="small"
          sx={{ mb: 2.5 }}
        />
      )}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      fullWidth
    />
  );
};



/* ===== CUSTOM LAYOUT RENDERERS TO INJECT SPACING ===== */
const CustomHorizontalLayoutRenderer = withJsonFormsLayoutProps((props) => {
  const { uischema, renderers, cells, schema, path, enabled, visible } = props;
  if (visible === false) return null;

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={1.5}>
        {uischema.elements.map((element, index) => (
          <Grid item xs={12} sm={element.options?.sm || (uischema.elements.length > 1 ? 6 : 12)} key={index} sx={{ minWidth: 0 }}>
            <JsonFormsDispatch
              schema={schema}
              uischema={element}
              path={path}
              enabled={enabled}
              renderers={renderers}
              cells={cells}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
});

const CustomVerticalLayoutRenderer = withJsonFormsLayoutProps((props) => {
  const { uischema, renderers, cells, schema, path, enabled, visible } = props;
  if (visible === false) return null;

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container direction="column" spacing={0}>
        {uischema.elements.map((element, index) => (
          <Grid item xs={12} key={index}>
            <JsonFormsDispatch
              schema={schema}
              uischema={element}
              path={path}
              enabled={enabled}
              renderers={renderers}
              cells={cells}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
});

// Helper functions defined outside component to avoid scoping issues
const trimStrings = (obj, excludeKeys = []) => {
  if (typeof obj === "string") {
    return obj.trim();
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => trimStrings(item, excludeKeys));
  }
  if (obj instanceof File) {
    return obj;
  }
  if (obj !== null && typeof obj === "object") {
    const newObj = {};
    for (let key in obj) {
      if (excludeKeys.includes(key)) {
        newObj[key] = obj[key]; // keep as-is
      } else {
        newObj[key] = trimStrings(obj[key], excludeKeys);
      }
    }
    return newObj;
  }
  return obj;
};

const ensureString = (val) => (val === null || val === undefined) ? "" : String(val);

const isValidJobItem = (item) => {
  if (!item) return false;
  // Fields to ignore when checking if the row is "empty"
  const ignoredFields = ['id', 'completed_time', 'add_to_brand', 'is_personal', 'prooflog_id'];
  return Object.entries(item).some(([key, value]) => {
    if (ignoredFields.includes(key)) return false;
    if (Array.isArray(value)) return value.length > 0;
    return value !== null && value !== undefined && String(value).trim() !== "";
  });
};

const getInvalidRequiredJobItems = (jobItems = [], pendingCorrection = null, mode = 'update') => {
  if (!Array.isArray(jobItems)) return [];

  const invalidItems = jobItems
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => item?.disabled !== true)
    .filter(({ item }) => isValidJobItem(item))
    .filter(({ item, index }) => {
      const itemNumber = String(item?.item || '').trim();
      const jobType = String(item?.job_type || '').trim();
      const submittedFiles = Array.isArray(item?.submitted_file) ? item.submitted_file : [];
      
      const hasInvalidCorrections = Array.isArray(item?.corrections) && item.corrections.some(corr => {
        return !String(corr?.description || '').trim() || !String(corr?.correction_type || '').trim();
      });

      // Also check if this specific item has a pending correction that is invalid
      const isPendingForThisItem = pendingCorrection && Number(pendingCorrection.itemIndex) === index;
      const hasInvalidPending = isPendingForThisItem && (!String(pendingCorrection.description || '').trim() || !String(pendingCorrection.correction_type || '').trim());

      // Mandatory validation for submitted files on create page OR for new rows, except for Typeset
      const isMissingSubmittedFile = (mode === 'create' || item?.__isNew === true) && 
        String(jobType).toLowerCase() !== 'typeset' && 
        submittedFiles.length === 0;

      return !itemNumber || !jobType || hasInvalidCorrections || hasInvalidPending || isMissingSubmittedFile;
    });

  return invalidItems;
};

const formatItemLabel = (v) => {
  const val = v.item?.item || '';
  if (typeof val === 'string' && val.toLowerCase().startsWith('item')) {
     return val.charAt(0).toUpperCase() + val.slice(1);
  }
  return `Item ${val || (v.index + 1)}`;
};

const isCancelledStage = (stage) => {
  if (!stage) return false;
  const normalized = String(stage).toLowerCase().trim();
  return normalized === 'cancelled' || normalized === 'canceled';
};

const isPdf = (u) => {
  if (!u || typeof u !== 'string') return false;
  return /\.pdf($|\?)/i.test(u);
};

const DEFAULT_VIRTUAL_REQUEST_PREFIX = 'Req';

/* ===== CUSTOM RENDERER FOR BUTTON ===== */
const ButtonRenderer = ({ uischema }) => {
  const dispatch = useDispatch();
  const { label, options } = uischema;
  const jobDetail = useSelector(state => state.job.job_detail);
  const currentJobId = useSelector(state => state.job.job_id);

  if (options?.onClickAction === "downloadZip" && (!jobDetail?.comp_file_list || jobDetail.comp_file_list.length <= 1)) {
    return null;
  }

  const handleClick = async () => {
    if (options?.onClickAction === 'downloadZip') {
      try {
        const response = await dispatch(download_zip_file({
          job_id: currentJobId,
          comp_file_list: jobDetail.comp_file_list
        })).unwrap();

        const blob = response.data || response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const ref_no = jobDetail?.job_data?.ref_No;
        const fileName = ref_no
          ? `${ref_no} - Completed files.zip`
          : "Completed files.zip";

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Zip download failed:", error);
        alert("Download failed.");
      }
    }
  };

  return (
    <Button
      variant={options?.variant || 'contained'}
      onClick={handleClick}
      sx={{ textTransform: 'none', background: '#ff6100' }}
    >
      {label}
    </Button>
  );
};

const getChangedFields = (originalData, newData) => {
  if (!originalData || !newData) return [];
  const changed = [];
  const excludeKeys = ['number_of_lines', 'stage', 'status', 'changed_fields'];
  
  const safeExtractValue = (val) => {
    if (val === null || val === undefined) return null;
    if (Array.isArray(val)) {
      return val.map(v => {
        if (v instanceof File) return v.name;
        if (v?.file instanceof File) return v.file.name;
        if (v?.file_path) return String(v.file_path);
        if (typeof v === 'string') return v;
        return v;
      });
    }
    if (val instanceof File) return val.name;
    if (val?.file instanceof File) return val.file.name;
    if (val?.file_path) return String(val.file_path);
    return val;
  };

  for (const key in newData) {
    if (excludeKeys.includes(key)) continue;
    
    let oldVal = originalData[key];
    let newVal = newData[key];
    
    if (oldVal === undefined) oldVal = null;
    if (newVal === undefined) newVal = null;

    if (key === 'job_items') {
      const oldItems = Array.isArray(oldVal) ? oldVal : [];
      const newItems = Array.isArray(newVal) ? newVal : [];
      const maxLen = Math.max(oldItems.length, newItems.length);
      
      for (let i = 0; i < maxLen; i++) {
        const oldItem = oldItems[i] || {};
        const newItem = newItems[i] || {};
        const itemKeys = new Set([...Object.keys(oldItem), ...Object.keys(newItem)]);
        const itemExclude = ['__isNew', 'disabled', 'id', 'line_id', 'corrections'];
        
        for (const iKey of itemKeys) {
          if (itemExclude.includes(iKey)) continue;
          
          let oldIVal = oldItem[iKey];
          let newIVal = newItem[iKey];
          if (oldIVal === undefined) oldIVal = null;
          if (newIVal === undefined) newIVal = null;
          
          const safeOldI = safeExtractValue(oldIVal);
          const safeNewI = safeExtractValue(newIVal);

          if (JSON.stringify(safeOldI) !== JSON.stringify(safeNewI)) {
            const itemName = newItem.item || `Item ${i + 1}`;
            changed.push({
               is_item: true,
               item_name: itemName,
               field: iKey,
               old: safeOldI,
               new: safeNewI
            });
          }
        }
      }
    } else {
      const safeOld = safeExtractValue(oldVal);
      const safeNew = safeExtractValue(newVal);

      if (JSON.stringify(safeOld) !== JSON.stringify(safeNew)) {
        changed.push({
           is_item: false,
           field: key,
           old: safeOld,
           new: safeNew
        });
      }
    }
  }
  return changed;
};

const JobForm = (props) => {
  const pendingCorrectionIds = useSelector(state => state.job.pending_correction_ids) || [];
  const pendingCorrection = useSelector(state => state.job.pending_correction);
  const { mode,
    job_form,
    job_data,
    handleJobForm,
    handleJobSubmit,
    job_id,
    job_detail,
    prev_stage,
    new_stage,
    proof_log_data,
    handleStatusChange,
    handleJobUpdate,
    handleZipDownload,
    job_update_flag
  } = props;
  const { selected_company, selected_process_tab, company_process_stage, company_users } = useSelector((state) => state.user);

  // Hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // State
  // State
  const getFullRepInfo = useCallback(() => {
    const authUser = isAuth();
    if (!authUser) return { rep_number: '', reps_email: '', rep_email: '', email: '' };

    const authEmail = (authUser.email || authUser.sub || authUser.username || "").toLowerCase();

    const extractRepNo = (u) => {
      if (!u) return '';
      return u.rep_number || u.rep_no || u.RepNumber || u.RepNo || u.repNo || '';
    };

    if (company_users?.length > 0 && authEmail) {
      const fullUser = company_users.find(
        u => u.email?.toLowerCase() === authEmail
      );

      if (fullUser) {
        console.log("[JobForm] Found Full User for rep info:", fullUser);
        const firstName = fullUser.first_name || '';
        const lastName = fullUser.last_name || '';
        const namePart = `${firstName} ${lastName}`.trim();
        const repNo = extractRepNo(fullUser);
        const repString = namePart && repNo ? `${namePart} - ${repNo}` : (namePart || repNo);

        return {
          rep_number: repString,
          reps_email: fullUser.email || '',
          rep_email: fullUser.email || '',
          email: fullUser.email || ''
        };
      }
    }

    // Fallback to auth token
    const firstName = authUser.first_name || '';
    const lastName = authUser.last_name || '';
    const namePart = `${firstName} ${lastName}`.trim();
    const repNo = extractRepNo(authUser);
    const repString = namePart && repNo ? `${namePart} - ${repNo}` : (namePart || repNo);

    return {
      rep_number: repString || '',
      reps_email: authUser.email || '',
      rep_email: authUser.email || '',
      email: authUser.email || ''
    };
  }, [company_users]);


  // State
  const [formData, setFormData] = useState(() => {
    if (mode === "create") {
      return {
        ...getFullRepInfo(),
        virtual_request: DEFAULT_VIRTUAL_REQUEST_PREFIX
      };
    }
    return null;
  });
  const [openBrandLibrary, setOpenBrandLibrary] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [openBrandLibraryTarget, setOpenBrandLibraryTarget] = useState(null); // 'completed_file' or 'logo_references'
  const [openBrandLibraryIsPersonal, setOpenBrandLibraryIsPersonal] = useState(false);
  const [logoLinkInput, setLogoLinkInput] = useState("");
  const isInitialized = useRef(false);
  const isDirty = useRef(false);
  const hasInitialized = useRef(false);
  const prevJobId = useRef(null);
  const [formErrors, setFormErrors] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
  const lastDataRef = useRef(null);

  // Fetch users if missing
  useEffect(() => {
    if ((!company_users || company_users.length === 0) && isAuth()) {
      dispatch(get_users_rep_dropdown());
    }
  }, [dispatch, company_users]);

  useEffect(() => {
    if (mode !== "create") return;
    if (!company_users?.length) return;

    const info = getFullRepInfo();
    if (info.reps_email) {
      setFormData(prev => {
        const current = prev || {};
        const isRepEmpty = !current.rep_number || current.rep_number.trim() === "" || current.rep_number.trim() === "-";
        const isEmailEmpty = !current.reps_email || current.reps_email.trim() === "";

        if (!isRepEmpty && !isEmailEmpty) return prev;

        return {
          ...current,
          virtual_request: current.virtual_request || DEFAULT_VIRTUAL_REQUEST_PREFIX,
          rep_number: isRepEmpty ? info.rep_number : current.rep_number,
          reps_email: isEmailEmpty ? info.reps_email : current.reps_email
        };
      });
    }
  }, [mode, company_users, getFullRepInfo]);

  const handleAddLogoLink = useCallback(() => {
    isDirty.current = true;
    if (!logoLinkInput.trim()) return;

    setFormData((prevData) => {
      const currentLogos = prevData.logo_references || [];
      const updatedLogos = [...currentLogos, logoLinkInput.trim()];
      const nextData = {
        ...prevData,
        logo_references: updatedLogos
      };

      setTimeout(() => {
        handleJobForm(nextData);
      }, 0);

      return nextData;
    });
    setLogoLinkInput("");
  }, [logoLinkInput, handleJobForm]);



  // Handle stage change specifically from JSONForms
  useEffect(() => {
    if (mode === 'update' && formData?.stage) {
      const selectedName = formData.stage;
      const selectedStage = company_process_stage?.find(s => s.name === selectedName);

      if (selectedStage && selectedStage.id !== formData.stage_id) {
        // If stage name changed, sync ID
        // We do this in a quiet way or let handleFormChange handle it?
        // handleFormChange handles logic, but let's ensure ID syncs if user picked from dropdown
      }
    }
  }, [formData?.stage, company_process_stage]);

  // Helper for nested updates
  const setNested = useCallback((obj, path, value) => {
    if (!path) return obj;
    // Handle both dot notation and slash notation (common in JSON Forms)
    const segments = path
      .replace(/\[(\d+)\]/g, '.$1')
      .replace(/\//g, '.')
      .split('.')
      .filter(Boolean);

    const update = (current, segs) => {
      if (segs.length === 0) return value;
      const [head, ...tail] = segs;

      if (Array.isArray(current)) {
        const next = [...current];
        next[head] = update(next[head] || {}, tail);
        return next;
      } else {
        const next = { ...(current || {}) };
        next[head] = update(next[head], tail);
        return next;
      }
    };

    return update(obj || {}, segments);
  }, []);

  const getNested = useCallback((obj, path) => {
    if (!obj || !path) return undefined;
    const segments = path
      .replace(/\[(\d+)\]/g, '.$1')
      .replace(/\//g, '.')
      .split('.')
      .filter(Boolean);
    let current = obj;
    for (const segment of segments) {
      if (current == null) return undefined;
      current = current[segment];
    }
    return current;
  }, []);

  const handleSelectFromLibrary = useCallback((items) => {
    isDirty.current = true;
    const selectedItems = Array.isArray(items) ? items : [items];
    const targetPath = openBrandLibraryTarget;

    if (!targetPath) {
      setOpenBrandLibrary(false);
      return;
    }
    const currentData = formData || {};
    const currentItems = getNested(currentData, targetPath) || [];
    const updatedItems = [...currentItems];

    const getFn = (url) => {
      if (!url) return "";
      try {
        return decodeURIComponent(url.split('?')[0].split('/').pop());
      } catch (e) { return url; }
    };

    selectedItems.forEach(item => {
      if (!item) return;

      if (typeof item === 'string') {
        // It's a pasted link
        const itemName = getFn(item);
        const exists = updatedItems.some(f => {
          let fName = "";
          if (f instanceof File) fName = f.name;
          else if (f.file instanceof File) fName = f.file.name;
          else if (typeof f === 'string') fName = getFn(f);
          else if (f.file && typeof f.file === 'string') fName = getFn(f.file);
          return fName === itemName;
        });

        if (!exists) {
          if (targetPath === 'logo_references') {
            updatedItems.push(item);
          } else {
            updatedItems.push({ file: item });
          }
        }
        return;
      }

      // It's a library object
      if (!item?.file_path) return;
      const itemName = getFn(item.file_path);

      if (targetPath === 'logo_references') {
        const exists = updatedItems.some(l => {
          const lName = (typeof l === 'string') ? getFn(l) : getFn(l?.file_path);
          return lName === itemName;
        });
        if (!exists) {
          updatedItems.push({
            file_path: item.file_path,
            id: item.id,
            prooflog_id: item.prooflog_id
          });
        }
      } else {
        const existingIndex = updatedItems.findIndex(f => {
          let fName = "";
          if (f instanceof File) fName = f.name;
          else if (f.file instanceof File) fName = f.file.name;
          else if (typeof f === 'string') fName = getFn(f);
          else if (f.file && typeof f.file === 'string') fName = getFn(f.file);
          return fName === itemName;
        });

        if (existingIndex !== -1) {
          const existing = updatedItems[existingIndex];
          const baseObj = (typeof existing === 'string')
            ? { file: existing }
            : (existing.file ? existing : { file: existing });

          updatedItems[existingIndex] = {
            ...baseObj,
            add_to_brand: true,
            prooflog_id: baseObj.prooflog_id || item.prooflog_id,
            name: item.name,
            search_param: item.search_param
          };
        } else {
          updatedItems.push({
            file: item.file_path,
            add_to_brand: true,
            prooflog_id: item.prooflog_id,
            name: item.name,
            search_param: item.search_param
          });
        }
      }
    });

    const nextData = setNested(currentData, targetPath, updatedItems);

    setFormData(nextData);
    setTimeout(() => {
      handleJobForm(nextData);
    }, 0);
    setOpenBrandLibrary(false);
  }, [formData, openBrandLibraryTarget, handleJobForm, getNested, setNested]);

  // LOOP PURPOSE: Syncs the current job's company and process ID to the global Redux state.
  useEffect(() => {
    if (mode === "update" && job_detail) {
      const jobCompanyId = job_detail.company_id;
      const jobProcessId = job_detail.process_id;

      // Only dispatch if they actually differ to avoid infinite loops
      if (jobCompanyId && String(selected_company) !== String(jobCompanyId)) {
        dispatch(setCompany(jobCompanyId));
      }

      // We must call this if the process ID doesn't match OR if the job_form is currently missing/empty
      // This is crucial for page refreshes where company_process might load AFTER job_detail.
      const isFormEmpty = !job_form || Object.keys(job_form).length === 0;
      if (jobProcessId && (String(selected_process_tab) !== String(jobProcessId) || isFormEmpty)) {
        console.log("[JobForm] Syncing Process ID:", jobProcessId, "isFormEmpty:", isFormEmpty);
        dispatch(setProcessTab(jobProcessId));
        dispatch(setProcessHasJobForm(jobProcessId));
      }
    }
    // eslint-disable-next-line
  }, [mode, job_detail?.company_id, job_detail?.process_id, dispatch, selected_company, selected_process_tab, job_form]);

  // LOOP PURPOSE: Triggers a form re-initialization when an external update happens (e.g. status change).
  useEffect(() => {
    if ((mode === "update" || mode === "detail") && job_detail) {
      // Always re-initialize when job_update_flag changes
      isInitialized.current = false;
      prevJobId.current = job_id;
    }
    // eslint-disable-next-line
  }, [job_update_flag]);

  useEffect(() => {
    if ((mode === "update" || mode === "detail") && job_detail && job_id) {
      if (prevJobId.current !== job_id) {
        isInitialized.current = false;
        prevJobId.current = job_id;
      }

      // If already initialized AND we have data, we can stay put unless the ID changed
      if (isInitialized.current && formData !== null) return;

      const { job_data } = job_detail;
      const completedFileDate =
        job_data?.completed_file_date ??
        job_data?.job_items?.[0]?.completed_file_date ??
        null;

      const { status, ...cleanJobData } = job_data || {};

      const normalizedJobItems = Array.isArray(job_data?.job_items)
        ? job_data.job_items.map((item) => ({
          ...item,
          __isNew: item?.__isNew === true,
          disabled: item?.disabled === true,
          id: ensureString(item?.id),
          item: ensureString(item?.item),
          line_id: ensureString(item?.line_id),
          product_color: ensureString(item?.product_color),
          imprint_color: ensureString(item?.imprint_color),
          pos_loc_placment: ensureString(item?.pos_loc_placment),
          imprint_method: ensureString(item?.imprint_method),
          imprint_instruction: ensureString(item?.imprint_instruction),
          vector_count: ensureString(item?.vector_count),
          complex_vector_count: ensureString(item?.complex_vector_count),
          job_type: ensureString(item?.job_type),
          complexity_level: ensureString(item?.complexity_level),
          standard_job_cost: ensureString(item?.standard_job_cost),
          complex_vector_cost: ensureString(item?.complex_vector_cost),
          total_cost: ensureString(item?.total_cost),
          cost: ensureString(item?.cost),
          no_of_revisions: ensureString(item?.no_of_revisions),
          revision_cost: ensureString(item?.revision_cost),
          ETA: ensureString(item?.ETA),
          comments: ensureString(item?.comments),
          submitted_date: ensureString(item?.submitted_date || item?.created_at),
          completed_time: ensureString(item?.completed_time),
          submitted_file: Array.isArray(item?.submitted_file) ? item.submitted_file : [],
          completed_file: Array.isArray(item?.completed_file) ? item.completed_file : [],
          eps_file: Array.isArray(item?.eps_file) ? item.eps_file : [],
          logo_file: Array.isArray(item?.logo_file) ? item.logo_file : []
        }))
        : [];

      const repInfo = getFullRepInfo();

      const formDataToSet = {
        ...cleanJobData,
        job_items: normalizedJobItems,
        number_of_lines: String(normalizedJobItems.length),
        job_type: job_data?.job_type || '',
        request_quote: job_data?.request_quote === true || job_data?.request_quote === 'true' || job_data?.request_quote === 1,
        stage: job_detail.stage?.name,
        status: job_detail.stage?.name || job_data?.stage || job_data?.status,
        created_date: formatDateTime(job_detail.created_date),
        submitted_date: job_data?.submitted_date || job_detail.created_date,
        reps_email: job_data?.reps_email || job_data?.rep_email || job_data?.email || repInfo.reps_email || "",
        rep_number: job_data?.rep_number || repInfo.rep_number || "",
        completed_file_date: completedFileDate ? completedFileDate : null
      };
      setFormData(formDataToSet);
      lastDataRef.current = formDataToSet;
      isInitialized.current = true;
      dispatch(setPrevStage(job_detail.stage?.name));
    }
  }, [mode, job_detail, dispatch, job_id, job_update_flag]);

  // REMOVE useEffect for create mode initialization

  const isEmptyData = (data) => {
    if (data instanceof File) return false;
    if (!data) return true;
    if (Array.isArray(data)) {
      return data.length === 0 || data.every(isEmptyData);
    }
    if (typeof data === "object") {
      if (Object.keys(data).length === 0) return true;

      return Object.values(data).every(isEmptyData);
    }
    return data === "" || data === null || data === undefined;
  };

  const hasEmptyCompletedFile = (data) => {
    // Check for top-level completed file
    const hasTopCompleted = Array.isArray(data.completed_file) && data.completed_file.length > 0;
    
    // Check if any job item has a completed file
    const hasAnyItemCompleted = Array.isArray(data.job_items) && data.job_items.some((item) => {
      return Array.isArray(item.completed_file) && item.completed_file.length > 0;
    });

    // Validation fails (returns true to alert) if NO completed files are found at all
    return !hasTopCompleted && !hasAnyItemCompleted;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const relevantErrors = formErrors?.filter(err => {
      const path = err.instancePath || "";
      const missingProp = err.params?.missingProperty || "";

      const isFileField =
        path.includes('submitted_file') ||
        path.includes('completed_file') ||
        missingProp === 'submitted_file' ||
        missingProp === 'completed_file';

      return !isFileField;
    }) || [];

    // if (relevantErrors.length > 0) {
    //   console.log("Validation errors:", relevantErrors);
    //   const errorDetail = relevantErrors.map(err => {
    //     const field = err.instancePath ? err.instancePath.replace(/^\//, '').replace(/\//g, '.') : (err.params?.missingProperty || "field");
    //     return `${field} ${err.message}`;
    //   }).join('; ');

    //   setSnackbar({ open: true, message: `Validation Error: ${errorDetail}`, severity: "error" });
    //   return;
    // }

    const trimmedData = trimStrings(formData, ["submitted_file", "completed_file"]);
    const hasJobItems = Array.isArray(trimmedData.job_items) && trimmedData.job_items.filter(isValidJobItem).length > 0;
    if (!hasJobItems) {
      alert("Add atleast one job item before submiting");
      return;
    }
    const invalidRequiredJobItems = getInvalidRequiredJobItems(trimmedData.job_items, pendingCorrection, mode);

    if (invalidRequiredJobItems.length > 0) {
      const itemsMissingFiles = invalidRequiredJobItems.filter(v => {
        const itemType = String(v.item?.job_type || '').trim();
        const files = Array.isArray(v.item?.submitted_file) ? v.item.submitted_file : [];
        return (mode === 'create' || v.item?.__isNew === true) && itemType.toLowerCase() !== 'typeset' && files.length === 0;
      });
      
      const otherInvalidItems = invalidRequiredJobItems.filter(v => !itemsMissingFiles.find(mf => mf.index === v.index));

      if (itemsMissingFiles.length > 0) {
        const itemNums = itemsMissingFiles.map(formatItemLabel).join(', ');
        setSnackbar({ open: true, message: `Please upload Submitted File(s) for Item# ${itemNums}`, severity: "error" });
        return;
      }
      
      if (otherInvalidItems.length > 0) {
        const itemNums = otherInvalidItems.map(formatItemLabel).join(', ');
        setSnackbar({ open: true, message: `Please complete all mandatory fields for Item# ${itemNums}.`, severity: "error" });
        return;
      }
    }

    // if (!trimmedData.description || !trimmedData.description.trim()) {
    //   setSnackbar({ open: true, message: "Description is required.", severity: "error" });
    //   return;
    // }
    const hasFiles = (
      (trimmedData.submitted_file && trimmedData.submitted_file.length > 0) ||
      (trimmedData.job_items && trimmedData.job_items.some(item => item.submitted_file && item.submitted_file.length > 0))
    );

    if (mode === "create" && !hasFiles && String(trimmedData.job_type || '').trim().toLowerCase() !== 'typeset') {
      const missingFileItems = (trimmedData.job_items || [])
        .map((item, index) => ({ item, index }))
        .filter(v => v.item && String(v.item.job_type || '').trim().toLowerCase() !== 'typeset' && (!Array.isArray(v.item.submitted_file) || v.item.submitted_file.length === 0));

      if (missingFileItems.length > 0) {
        const itemNums = missingFileItems.map(formatItemLabel).join(', ');
        setSnackbar({ open: true, message: `Please upload Submitted File(s) for Item# ${itemNums}`, severity: "error" });
        return;
      }
    }


    const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // Validate any email fields present in the form data
    const emailFieldsToCheck = ['Rep Email', 'Reps Email', 'reps_email', 'rep_email', 'customer_email', 'client_email', 'email'];
    for (const field of emailFieldsToCheck) {
      const emailValue = trimmedData[field];
      if (emailValue && typeof emailValue === 'string') {
        const trimmedEmail = emailValue.trim();
        // If it's a comma-separated list of emails, validate each
        const emails = trimmedEmail.split(/[\s,]+/);
        if (!emails.every(e => isValidEmail(e))) {
           setSnackbar({
             open: true,
             message: `Please enter a valid email address for ${field.replace(/_/g, ' ')}`,
             severity: "error"
           });
           return;
        }
      }
    }

    if (trimmedData.send_art_to_customer) {
      const email = trimmedData.customer_email?.trim();

      if (!email || !isValidEmail(email)) {
        setSnackbar({
          open: true,
          message: "Please enter a valid Customer Email address when 'Send Art to Customer' is checked.",
          severity: "error"
        });
        return;
      }
    }

    if (isEmptyData(trimmedData)) {
      setSnackbar({ open: true, message: "Please complete the mandatory fields.", severity: "error" });
      return;
    }

    try {
      dispatch(setCommonLoading(true));
      if (mode === "create") {
        if (trimmedData?.request_quote === true) {
          trimmedData.stage_id = 8;
          trimmedData.stage = "Quote Requested";
        } else if (!trimmedData.stage_id || trimmedData.stage_id === "") {
          trimmedData.stage_id = 1;
          trimmedData.stage = "New";
        }
      }

      // Filter out empty job items and update count one last time
      if (Array.isArray(trimmedData.job_items)) {
        trimmedData.job_items = trimmedData.job_items
          .filter(isValidJobItem)
          .map((item) => {
            const { pending_correction, ...restItem } = item || {};
            return restItem;
          });
        trimmedData.number_of_lines = String(trimmedData.job_items.length);
      }

      const res = await handleJobSubmit(trimmedData, selected_company);
      if (res?.meta?.requestStatus === 'rejected') {
        alert("Job creation failed: " + (res.payload?.detail || res.payload || "Unknown error"));
        return;
      }

      const targetStage = trimmedData.stage_id || 1;
      dispatch(clearJobData());
      window.location.href = `/?process_id=${selected_process_tab || targetStage}`;

    } catch (error) {
      console.error("Job creation failed:", error);
      alert("Job creation failed: " + error.message);
    } finally {
      dispatch(setCommonLoading(false));
    }
  };

  const handleApproveQuote = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const approvalNeededStage = company_process_stage?.find(s => s.name === "Approval Needed");

    if (!approvalNeededStage) {
      console.error("Stage 'Approval Needed' not found");
      alert("Stage 'Approval Needed' not found in the current process.");
      return;
    }

    const newData = {
      ...formData,
      stage: approvalNeededStage.name,
      stage_id: approvalNeededStage.id
    };
    setFormData(newData);
    setSnackbar({
      open: true,
      message: "Stage set to 'Approval Needed'. Click UPDATE to save changes.",
      severity: "success"
    });
  };

  const handleUpdate = async (e, dataOverride = null) => {
    if (e) e.preventDefault();

    const dataToUse = dataOverride || formData;
    const trimmedData = trimStrings(dataToUse, ["submitted_file", "completed_file"]);
    const shouldValidateRequiredJobItems = !isCancelledStage(trimmedData.stage || trimmedData.status || new_stage);
    const invalidRequiredJobItems = shouldValidateRequiredJobItems
      ? getInvalidRequiredJobItems(trimmedData.job_items, pendingCorrection, mode)
      : [];

    if (invalidRequiredJobItems.length > 0) {
      const itemsMissingFiles = invalidRequiredJobItems.filter(v => {
        const itemType = String(v.item?.job_type || '').trim();
        const files = Array.isArray(v.item?.submitted_file) ? v.item.submitted_file : [];
        return (mode === 'create' || v.item?.__isNew === true) && itemType.toLowerCase() !== 'typeset' && files.length === 0;
      });
      
      const otherInvalidItems = invalidRequiredJobItems.filter(v => !itemsMissingFiles.find(mf => mf.index === v.index));

      if (itemsMissingFiles.length > 0) {
        const itemNums = itemsMissingFiles.map(formatItemLabel).join(', ');
        setSnackbar({ open: true, message: `Please upload Submitted File(s) for Item# ${itemNums}`, severity: "error" });
        return;
      }
    }


    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // Validate any email fields present in the form data
    const emailFieldsToCheck = ['Rep Email', 'Reps Email', 'reps_email', 'rep_email', 'customer_email', 'client_email', 'email'];
    for (const field of emailFieldsToCheck) {
      const emailValue = trimmedData[field];
      if (emailValue && typeof emailValue === 'string') {
        const trimmedEmail = emailValue.trim();
        if (trimmedEmail) {
          // If it's a comma-separated list of emails, validate each
          const emails = trimmedEmail.split(/[\s,]+/);
          if (!emails.every(e => isValidEmail(e))) {
             setSnackbar({
               open: true,
               message: `Please enter a valid email address for ${field.replace(/_/g, ' ')}`,
               severity: "error"
             });
             return;
          }
        }
      }
    }

    if (isEmptyData(trimmedData)) {
      setSnackbar({ open: true, message: "Please complete the mandatory fields.", severity: "error" });
      return;
    }


    const processNewCorrection = async (data) => {
      if (!pendingCorrection) return;

      const { itemIndex, description, correction_type, files } = pendingCorrection;
      const jobItem = data.job_items?.[itemIndex];
      const itemId = jobItem?.id;

      if (!itemId) {
        console.warn("Could not find item ID for pending correction at index", itemIndex);
        return;
      }

      await dispatch(add_correction({
        job_id: job_id,
        item_id: itemId,
        correction_data: {
          description,
          correction_type,
          job_type: pendingCorrection?.job_type || '',
          vector_count: pendingCorrection?.vector_count || '',
          complex_vector_count: pendingCorrection?.complex_vector_count || '',
          standard_job_cost: pendingCorrection?.standard_job_cost || '',
          complex_vector_cost: pendingCorrection?.complex_vector_cost || '',
          total_cost: pendingCorrection?.total_cost || '',
          revision_comments: pendingCorrection?.revision_comments || '',
          logo_reference: Array.isArray(pendingCorrection?.logo_reference) ? pendingCorrection.logo_reference : []
        },
        files: files || {}
      })).unwrap();
      
      dispatch(clearPendingCorrection());
    };

    const processCorrectionUpdates = async (data) => {
      if (pendingCorrectionIds.length === 0) return;
      
      const jobItems = data.job_items || [];
      for (const item of jobItems) {
        const corrections = item.corrections || [];
        for (const corr of corrections) {
          if (pendingCorrectionIds.includes(corr.id)) {
            const payload = {
              job_id: job_id,
              item_id: item.id || '',
              correction_id: corr.id,
              correction_data: {
                description: corr.description,
                correction_type: corr.correction_type,
                logo_reference: Array.isArray(corr.logo_reference) ? corr.logo_reference : [],
                job_type: corr.job_type || '',
                vector_count: corr.vector_count || '',
                complex_vector_count: corr.complex_vector_count || '',
                standard_job_cost: corr.standard_job_cost || '',
                complex_vector_cost: corr.complex_vector_cost || '',
                total_cost: corr.total_cost || '',
                revision_comments: corr.revision_comments || ''
              },
              files: {
                submitted_file: corr.submitted_file || [],
                completed_file: corr.completed_file || [],
                eps_file: corr.eps_file || [],
                logo_file: corr.logo_file || []
              }
            };
            await dispatch(update_correction(payload));
          }
        }
      }
      dispatch(clearPendingCorrectionIds());
    };

    const isCompletedStage = (stage) => {
      if (!stage) return false;
      return typeof stage === 'string' && stage.toLowerCase().trim() === "completed";
    };
    const isRevisionStage = (stage) => {
      if (!stage) return false;
      return typeof stage === 'string' && stage.toLowerCase().trim() === "revision";
    };
    const targetStageName = dataToUse.stage || dataToUse.status || new_stage;

    if (isCompletedStage(targetStageName) && hasEmptyCompletedFile(trimmedData)) {
      alert("Upload Completed File before marking job as Completed");
      return;
    }

    const hasPendingCorrections = pendingCorrection || (Array.isArray(pendingCorrectionIds) && pendingCorrectionIds.length > 0);
    if (hasPendingCorrections && !isRevisionStage(targetStageName)) {
      alert('Please change "Status" to "Revision" before saving');
      return;
    }

    // Filter out empty job items and strip anomalous ID-less corrections
    if (Array.isArray(trimmedData.job_items)) {
      trimmedData.job_items = trimmedData.job_items.filter(isValidJobItem).map(item => {
        const { pending_correction, ...restItem } = item || {};
        return {
          ...restItem,
          corrections: Array.isArray(item?.corrections) ? item.corrections.filter(c => c && c.id && String(c.id).trim() !== "") : []
        };
      });
      trimmedData.number_of_lines = String(trimmedData.job_items.length);
    }

    if (prev_stage !== targetStageName && isCompletedStage(targetStageName)) {
      alert("The job has been updated since you began working on it. Please review the Job Log for all the changes before Completing.");
    }

    try {
      dispatch(setCommonLoading(true));
      const result = await handleJobUpdate(trimmedData, job_id);
      if (result.meta?.requestStatus === 'rejected') {
        throw new Error(result.payload || "Job update failed");
      }

      // const successDetail = result.payload?.data?.detail;
      // if (successDetail) {
      //   alert(successDetail);
      // }

      // Check stage change logic
      const currentStageName = dataToUse.stage;

      if (prev_stage && currentStageName && prev_stage !== currentStageName) {
        const action_type = 2;
        const payload = { job_id, action_type, prev_stage, new_stage: currentStageName };
        handleStatusChange(payload).catch(err => console.error("Background status change failed:", err));
      }

      dispatch(clearJobData());
      const url = selected_process_tab ? `/job-detail/${job_id}?process_id=${selected_process_tab}` : `/job-detail/${job_id}`;
      navigate(url);
      const params = {
        company_id: job_detail.company_id,
        process_id: job_detail.process_id,
      };
      dispatch(get_company_process_stage(params));
      dispatch(get_sidebar_menu(job_detail.process_id));
    } catch (error) {
      console.error("Job update failed:", error);
      alert("Job update failed: " + error.message);
    } finally {
      dispatch(setCommonLoading(false));
    }
  };

  const handleDownloadZipFile = async (job_id, comp_file_list) => {
    const ref_no = job_detail?.job_data?.ref_No;
    handleZipDownload(job_id, comp_file_list, ref_no)
  };

  const handleCancel = () => {
    dispatch(clearJobData());

    if (mode === "create") {
      navigate('/');
    }

    if (mode === "update") {
      const url = selected_process_tab ? `/job-detail/${job_id}?process_id=${selected_process_tab}` : `/job-detail/${job_id}`;
      navigate(url);
    }
  };

  /* ==============================================================================================
     MEMOIZED PROPS & SCHEMAS
     ============================================================================================== */


  const buttonTester = useMemo(() => rankWith(
    11,
    uischema => isControl(uischema) && uischema.options?.renderer === 'button'
  ), []);



  /* ---------------------------------------------------------------------------------------------- */

  const submittedDatelabelTester = useMemo(() => rankWith(5, (uischema) =>
    uischema.type === 'Submitted Date Label' || uischema.scope === '#/properties/submitted_date'
  ), []);
  const completedDatelabelTester = useMemo(() => rankWith(5, (uischema) =>
    uischema.type === 'Completed Date Label' || uischema.scope === '#/properties/completed_date' || uischema.scope === '#/properties/completed_file_date'
  ), []);
  const numberOfLinesTester = useMemo(() => rankWith(5, (uischema) =>
    uischema.scope === '#/properties/number_of_lines'
  ), []);
  const repNumberTester = useMemo(() => rankWith(10, (uischema) =>
    uischema.scope === '#/properties/rep_number'
  ), []);
  const repsEmailTester = useMemo(() => rankWith(10, (uischema) =>
    uischema.scope === '#/properties/reps_email'
  ), []);
  const virtualRequestTester = useMemo(() => rankWith(10, (uischema) =>
    uischema.scope === '#/properties/virtual_request'
  ), []);
  const borderedBooleanTester = useMemo(() => rankWith(3, and(uiTypeIs('Control'), optionIs('renderer', 'BorderedBoolean'))), []);
  const descriptionTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/description'), []);
  const referenceTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/ref_No'), []);
  const requestQuoteTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/request_quote'), []);
  const needQuoteTester = useMemo(() => rankWith(4, (uischema) => uischema.scope === '#/properties/i_need_a_quote'), []);
  const jobItemsTester = useMemo(() => rankWith(100, scopeEndsWith('job_items')), []);

  const fileInputTester = useMemo(() => rankWith(
    10,
    uischema => {
      const match = isControl(uischema) &&
        typeof uischema.scope === 'string' &&
        uischema.options?.renderer === 'fileInputTester';

      return match;
    }
  ), []);

  const fileInputWithBrandTester = useMemo(() => rankWith(
    12,
    uischema => {
      const match = isControl(uischema) &&
        typeof uischema.scope === 'string' &&
        (
          uischema.options?.renderer === 'FileInputWithBrandOption' ||
          uischema.options?.renderer === 'FileInputField' ||
          uischema.scope.endsWith('/submitted_file') ||
          uischema.scope.endsWith('/completed_file')
        );

      return match;
    }
  ), []);

  // Stable renderer components for FileWidget
  const FileWidgetRenderer = useMemo(() => (props) => (
    <FileWidget
      {...props}
      // Check if it's a completed file field
      showBrandOption={mode === 'detail' && props.path && (String(props.path).includes('completed') || String(props.path).includes('comp_file'))}
      showLibraryLink={!(props.path && (String(props.path).includes('completed') || String(props.path).includes('comp_file')))}
      compact={props.path && String(props.path).includes('job_items')}
      onOpenLibrary={() => {
        setOpenBrandLibraryTarget(props.path);
        setOpenBrandLibrary(true);
      }}
    />
  ), []);

  const FileWidgetWithBrandRenderer = useMemo(() => (props) => (
    <FileWidget
      {...props}
      // Check if it's a completed file field
      showBrandOption={mode === 'detail' && props.path && (String(props.path).includes('completed') || String(props.path).includes('comp_file'))}
      showLibraryLink={!(props.path && (String(props.path).includes('completed') || String(props.path).includes('comp_file')))}
      compact={props.path && String(props.path).includes('job_items')}
      onOpenLibrary={() => {
        setOpenBrandLibraryTarget(props.path);
        setOpenBrandLibrary(true);
      }}
    />
  ), []);

  // Create a stable reference to the handler to avoid breaking renderers memoization
  const handleApproveQuoteRef = useRef(handleApproveQuote);
  useEffect(() => {
    handleApproveQuoteRef.current = handleApproveQuote;
  }); // Update ref on every render

  const stableApproveQuoteHandler = useCallback((e) => {
    if (handleApproveQuoteRef.current) {
      handleApproveQuoteRef.current(e);
    }
  }, []);



  const initialRequestQuote = useMemo(() => {
    if (mode !== 'update') return false;
    const val = job_detail?.job_data?.request_quote;
    return val === true || val === 'true' || val === 1;
  }, [mode, job_detail]);

  const initialNeedQuote = useMemo(() => {
    if (mode !== 'update') return false;
    const val = job_detail?.job_data?.i_need_a_quote;
    return val === true || val === 'true' || val === 1;
  }, [mode, job_detail]);

  const BoundRequestQuoteRenderer = useMemo(() => {
    // Pass currentStage to allow the button to show "Approved" state
    const Wrapper = (props) => {
      const ctx = useJsonForms();
      const currentStage = ctx?.core?.data?.stage;
      return (
        <RequestQuoteRenderer
          {...props}
          mode={mode}
          handleApproveQuote={stableApproveQuoteHandler}
          currentStage={currentStage}
          initialRequestQuote={initialRequestQuote}
        />
      );
    };
    return withJsonFormsControlProps(Wrapper);
  }, [mode, stableApproveQuoteHandler, initialRequestQuote]);

  const BoundNeedQuoteRenderer = useMemo(() => {
    const Wrapper = (props) => {
      const ctx = useJsonForms();
      const currentStage = ctx?.core?.data?.stage;
      return (
        <RequestQuoteRenderer
          {...props}
          mode={mode}
          handleApproveQuote={stableApproveQuoteHandler}
          currentStage={currentStage}
          // Repurpose the prop to pass the correct initial value
          initialRequestQuote={initialNeedQuote}
        />
      );
    };
    return withJsonFormsControlProps(Wrapper);
  }, [mode, stableApproveQuoteHandler, initialNeedQuote]);

  const logoNameTester = useMemo(() => rankWith(10, (uischema) =>
  uischema.scope === '#/properties/logo_name'
), []);

const LogoNameRendererFn = ({ data, handleChange, path, label, required, enabled }) => {
  const cleanLabel = (label || "").replace(/\s?\*$/, "").replace(/\s?\*$/, ""); // Double check for any doubled asterisks
  return (
    <TextField
      label={cleanLabel}
      value={data || ""}
      onChange={(e) => handleChange(path, e.target.value)}
      required={false}
      disabled={!enabled}
      fullWidth
      variant="outlined"
      size="small"
      sx={{ mb: 2.5 }}
    />
  );
};
const LogoNameRenderer = withJsonFormsControlProps(LogoNameRendererFn);

  const renderers = useMemo(() => [
    { tester: rankWith(3, uiTypeIs('HorizontalLayout')), renderer: CustomHorizontalLayoutRenderer },
    { tester: rankWith(3, uiTypeIs('VerticalLayout')), renderer: CustomVerticalLayoutRenderer },
    ...materialRenderers,
    { tester: logoNameTester, renderer: LogoNameRenderer },
    { tester: fileInputTester, renderer: FileWidgetRenderer },
    { tester: fileInputWithBrandTester, renderer: FileWidgetWithBrandRenderer },
    { tester: buttonTester, renderer: withJsonFormsLayoutProps(ButtonRenderer) },
    { tester: submittedDatelabelTester, renderer: withJsonFormsLayoutProps(SubmittedDateLabelRenderer) },
    { tester: completedDatelabelTester, renderer: withJsonFormsLayoutProps(CompletedDateLabelRenderer) },
    { tester: borderedBooleanTester, renderer: withJsonFormsControlProps(BorderedBooleanRenderer) },
    { tester: descriptionTester, renderer: withJsonFormsControlProps(DescriptionRenderer) },
    { tester: referenceTester, renderer: withJsonFormsControlProps(ReferenceRenderer) },
    { tester: numberOfLinesTester, renderer: withJsonFormsControlProps(ReadOnlyGreyRenderer) },
    { tester: repNumberTester, renderer: withJsonFormsControlProps(ReadOnlyGreyRenderer) },
    { tester: repsEmailTester, renderer: withJsonFormsControlProps(ReadOnlyGreyRenderer) },
    { tester: virtualRequestTester, renderer: withJsonFormsControlProps(ReadOnlyGreyRenderer) },

    { tester: requestQuoteTester, renderer: BoundRequestQuoteRenderer },
    { tester: needQuoteTester, renderer: BoundNeedQuoteRenderer },
    { tester: jobItemsTester, renderer: JobItemsTableRenderer }
  ], [
    mode,
    buttonTester,
    submittedDatelabelTester,
    completedDatelabelTester,
    borderedBooleanTester,
    descriptionTester,
    referenceTester,
    requestQuoteTester,
    BoundRequestQuoteRenderer,
    needQuoteTester,
    BoundNeedQuoteRenderer,
    fileInputTester,
    fileInputWithBrandTester,
    FileWidgetRenderer,
    FileWidgetWithBrandRenderer,
    jobItemsTester
  ]);

  // Stabilize the boolean for optional schema logic
  const hasNoCompletedFiles = useMemo(() => {
    return mode === "update" && (!job_detail?.comp_file_list || job_detail.comp_file_list.length === 0);
  }, [mode, job_detail?.comp_file_list]);

  // Stabilize the schema objects for dependency array
  // const jobSchemaStr = useMemo(() => JSON.stringify(job_form?.job_schema), [job_form]);
  // const uiSchemaStr = useMemo(() => JSON.stringify(mode === "update" ? job_form?.job_ui_update_schema : job_form?.job_ui_schema), [job_form, mode]);

  // Create stable reference for stage names to allow proper comparison
  const stagesStr = useMemo(() => {
    return company_process_stage?.map(s => s.name).join(',') || '';
  }, [company_process_stage]);

  const jobSchemaStr = useMemo(() => JSON.stringify(job_form?.job_schema), [job_form?.job_schema]);
  const rawSchema = useMemo(() => jobSchemaStr ? JSON.parse(jobSchemaStr) : null, [jobSchemaStr]);

  const jobUiSchemaStr = useMemo(() => {
    const uiSchema = (mode === "update" && job_form?.job_ui_update_schema)
      ? job_form.job_ui_update_schema
      : job_form?.job_ui_schema;
    return JSON.stringify(uiSchema);
  }, [job_form, mode]);
  const rawUiSchema = useMemo(() => jobUiSchemaStr ? JSON.parse(jobUiSchemaStr) : null, [jobUiSchemaStr]);

  const dynamicSchema = useMemo(() => {
    if (!rawSchema || !rawUiSchema) return null;

    const schemaCopy = JSON.parse(JSON.stringify(rawSchema));
    // Ensure properties object exists
    if (!schemaCopy.properties) {
      schemaCopy.properties = {};
    }


    const uiSchemaCopy = JSON.parse(JSON.stringify(rawUiSchema));

    // Ensure stage property exists in update mode
    if (mode === "update") {
      if (!schemaCopy.properties) {
        schemaCopy.properties = {};
      }
      if (!schemaCopy.properties.stage) {
        schemaCopy.properties.stage = {
          type: "string",
          title: "Stage",
          enum: company_process_stage?.length
            ? [...new Set(company_process_stage.map(s => s.name).filter(n => n !== "Brand Library" && n !== "My Library"))]
            : ["Received", "In Progress", "On Hold", "Completed", "Cancelled"]
        };
      }

      // Ensure UI schema has the stage control and is NOT read-only
      const stageScope = "#/properties/stage";
      const hasStageControl = (layout) => {
        if (!layout) return false;
        if (layout.scope === stageScope) return true;
        if (layout.elements) return layout.elements.some(hasStageControl);
        return false;
      };

      // Helper to remove readOnly from stage control if found
      const enableStageControl = (layout) => {
        if (!layout) return;
        if (layout.scope === stageScope) {
          if (layout.options) {
            layout.options.readOnly = false;
            delete layout.options.readonly;
          }
        }
        if (layout.elements) {
          layout.elements.forEach(enableStageControl);
        }
      };

      if (uiSchemaCopy) {
        enableStageControl(uiSchemaCopy);
      }
    }

    if (company_process_stage?.length && schemaCopy.properties?.stage) {
      schemaCopy.properties.stage.enum = [...new Set(company_process_stage.map(
        (stage) => stage.name
      ).filter(n => n !== "Brand Library" && n !== "My Library"))];
    }

    // PATCH: Ensure commonly used fields exist in schema to avoid "No renderer found"
    const ensureProperty = (propName, type = 'string', title = undefined) => {
      if (!schemaCopy.properties[propName]) {
        schemaCopy.properties[propName] = { type, title };
      }
    };

    ensureProperty('virtual_request', 'string', 'Virtual Request #');
    ensureProperty('logo_name');
    ensureProperty('job_type');
    ensureProperty('instructions');
    ensureProperty('i_need_a_quote', 'boolean', 'I Need a Quote');
    ensureProperty('release_date', 'string');
    ensureProperty('completed_date', 'string');
    ensureProperty('company_name');
    ensureProperty('search_tags');
    ensureProperty('description');
    ensureProperty('submitted_date');
    ensureProperty('submitted_file', 'array');
    ensureProperty('completed_file', 'array');
    ensureProperty('logo_references', 'array');
    ensureProperty('job_items', 'array');
    ensureProperty('stage_id', 'integer');
    ensureProperty('stage', 'string');
    ensureProperty('status', 'string');
    ensureProperty('submitted_date', 'string');
    ensureProperty('send_art_to_customer', 'boolean', 'Send Art to Customer');
    ensureProperty('customer_email', 'string', 'Customer Email');
    ensureProperty('number_of_lines', 'string');
    ensureProperty('rep_number');
    ensureProperty('reps_email');
    ensureProperty('rep_email');
    ensureProperty('email');

    const userRole = Number(isAuth()?.role);
    const isAddnectarUser = [
      SUPER_ADMIN,
      ADMIN,
      ADDNECTAR_ADMIN,
      ADDNECTAR_ARTIST,
      ADDNECTAR_MANAGER,
      ADDNECTAR_ACCOUNT_MANAGER
    ].includes(userRole);

    if (isAddnectarUser) {
      ensureProperty('remarks', 'string', 'Remarks');
    }

    // Force job_items to be array
    if (schemaCopy.properties.job_items) {
      schemaCopy.properties.job_items.type = 'array';
    } else {
      schemaCopy.properties.job_items = {
        type: "array",
        title: "Job Items",
        items: {
          type: "object",
          properties: {}
        }
      };
    }

    // Place job_items UI element right after the Instructions control
    const placeJobItemsBelowInstructions = (ui) => {
      if (!ui || !ui.elements) return;
      let jobEl = null;

      const removeJob = (elements) => {
        if (!elements) return;
        for (let i = elements.length - 1; i >= 0; i--) {
          const el = elements[i];
          if (!el) continue;

          if (el.scope === "#/properties/job_items") {
            jobEl = el;
            elements.splice(i, 1);
          } else if (el.elements) {
            removeJob(el.elements);
          } else if (el.options?.detail?.elements) {
            removeJob(el.options.detail.elements);
          }
        }
      };

      // Remove job_items from wherever it is
      removeJob(ui.elements);

      if (!jobEl) return;

      let inserted = false;
      const insertAfterInstructions = (elements) => {
        if (!elements) return false;
        for (let i = 0; i < elements.length; i++) {
          const el = elements[i];
          if (!el) continue;

          if (el.scope === "#/properties/instructions") {
            elements.splice(i + 1, 0, jobEl);
            inserted = true;
            return true;
          }

          if (el.elements && insertAfterInstructions(el.elements)) return true;
          if (el.options && el.options.detail && Array.isArray(el.options.detail.elements) && insertAfterInstructions(el.options.detail.elements)) return true;
        }
        return false;
      };

      insertAfterInstructions(ui.elements);

      // Fallback: append to end if we couldn't find Instructions
      if (!inserted) ui.elements.push(jobEl);
    };

    placeJobItemsBelowInstructions(uiSchemaCopy);

    // Ensure job_items items has properties
    if (schemaCopy.properties.job_items.type === 'array') {
      if (!schemaCopy.properties.job_items.items) {
        schemaCopy.properties.job_items.items = { type: "object", properties: {} };
      }
      if (!schemaCopy.properties.job_items.items.properties) {
        schemaCopy.properties.job_items.items.properties = {};
      }

      const itemProps = schemaCopy.properties.job_items.items.properties;
      const ensureItemProp = (pName, pType = 'string') => {
        if (!itemProps[pName]) itemProps[pName] = { type: pType };
      };

      ensureItemProp('disabled', 'boolean');
      ensureItemProp('id');
      ensureItemProp('item');
      ensureItemProp('line_id');
      ensureItemProp('product_color');
      ensureItemProp('imprint_color');
      ensureItemProp('pos_loc_placment');
      ensureItemProp('imprint_method');
      ensureItemProp('imprint_instruction');
      ensureItemProp('vector_count');
      ensureItemProp('complex_vector_count');
      ensureItemProp('job_type');
      ensureItemProp('complexity_level');
      ensureItemProp('standard_job_cost');
      ensureItemProp('complex_vector_cost');
      ensureItemProp('total_cost');
      ensureItemProp('cost');
      ensureItemProp('no_of_revisions');
      ensureItemProp('revision_cost');
      ensureItemProp('ETA');
      ensureItemProp('comments');
      ensureItemProp('correction_type');
      ensureItemProp('completed_time');
      ensureItemProp('submitted_file', 'array');
      ensureItemProp('completed_file', 'array');
      ensureItemProp('eps_file', 'array');
      ensureItemProp('logo_file', 'array');
      ensureItemProp('pending_correction', 'object');
      ensureItemProp('corrections', 'array');

      if (!Array.isArray(schemaCopy.properties.job_items.items.required)) {
        schemaCopy.properties.job_items.items.required = [];
      }
      if (!schemaCopy.properties.job_items.items.required.includes('item')) {
        schemaCopy.properties.job_items.items.required.push('item');
      }
      if (!schemaCopy.properties.job_items.items.required.includes('job_type')) {
        schemaCopy.properties.job_items.items.required.push('job_type');
      }

      const stripDefaults = (obj) => {
        if (!obj || typeof obj !== 'object') return;
        if (Array.isArray(obj)) {
          obj.forEach(stripDefaults);
        } else {
          delete obj.default;
          Object.values(obj).forEach(stripDefaults);
        }
      };

      // Strip any default data that might cause "Test" corrections
      stripDefaults(itemProps.corrections);
      stripDefaults(itemProps.pending_correction);
      if (schemaCopy.properties.job_items.items) {
          delete schemaCopy.properties.job_items.items.default;
      }
    }

    // Verify and setup rule for customer_email
    let stageFound = false;
    let customerEmailFound = false;
    let sendArtLocation = null; // { elements, index }

    let repsEmailFound = false;
    let repNumberFound = false;

    const scanForFields = (elements) => {
      if (!elements) return;
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        if (!el) continue;

        // Hide submitted_date and status in Create Job page (mode !== "update")
        if (mode !== "update" && (el.scope === "#/properties/submitted_date" || el.scope === "#/properties/status" || el.scope === "#/properties/stage")) {
          elements.splice(i, 1);
          i--;
          continue;
        }

        // Always hide proof_request_type from all job pages
        if (el.scope === "#/properties/proof_request_type") {
          elements.splice(i, 1);
          i--;
          continue;
        }

        // Disable number_of_lines in both Create and Update pages
        if (el.scope === "#/properties/number_of_lines") {
          el.options = { ...el.options, readOnly: true };
        }

        if (el.scope === "#/properties/rep_number" || el.scope === "#/properties/reps_email") {
          el.options = { ...el.options, readOnly: true };
        }

        if (el.scope === "#/properties/stage" || el.scope === "#/properties/status") {
          stageFound = true;
          el.label = "Status"; // Force label to Status
        }
        if (el.scope === "#/properties/customer_email") {
          customerEmailFound = true;
          // Apply rule to existing control
          el.rule = {
            effect: "SHOW",
            condition: {
              scope: "#/properties/send_art_to_customer",
              schema: { const: true }
            }
          };
        }
        if (el.scope === "#/properties/reps_email") repsEmailFound = true;
        if (el.scope === "#/properties/rep_number") repNumberFound = true;

        if (el.scope === "#/properties/send_art_to_customer") {
          sendArtLocation = { elements, index: i };
        }

        if (el.elements) scanForFields(el.elements);
        if (el.options?.detail?.elements) scanForFields(el.options.detail.elements);
      }
    };

    scanForFields(uiSchemaCopy.elements);

    // If customer_email not found but send_art_to_customer is found, insert it
    if (!customerEmailFound && sendArtLocation) {
      sendArtLocation.elements.splice(sendArtLocation.index + 1, 0, {
        type: "Control",
        scope: "#/properties/customer_email",
        label: "Customer Email",
        rule: {
          effect: "SHOW",
          condition: {
            scope: "#/properties/send_art_to_customer",
            schema: { const: true }
          }
        }
      });
    }

    // If send_art_to_customer not found at all, inject both near Instructions
    if (!sendArtLocation) {
      let instructionsLoc = null;
      const findInstr = (elements) => {
        if (!elements) return;
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].scope === "#/properties/instructions") {
            instructionsLoc = { elements, index: i };
            return;
          }
          if (elements[i].elements) findInstr(elements[i].elements);
          if (elements[i].options?.detail?.elements) findInstr(elements[i].options.detail.elements);
        }
      };
      findInstr(uiSchemaCopy.elements);

      const targetElems = instructionsLoc ? instructionsLoc.elements : uiSchemaCopy.elements;
      const targetIdx = instructionsLoc ? instructionsLoc.index + 1 : targetElems.length;

      targetElems.splice(targetIdx, 0, {
        type: "Control",
        scope: "#/properties/send_art_to_customer",
        label: "Send Art to Customer"
      });

      if (!customerEmailFound) {
        targetElems.splice(targetIdx + 1, 0, {
          type: "Control",
          scope: "#/properties/customer_email",
          label: "Customer Email",
          rule: {
            effect: "SHOW",
            condition: {
              scope: "#/properties/send_art_to_customer",
              schema: { const: true }
            }
          }
        });
      }
    }

    // Ensure Rep Number and Reps Email are in UI Schema if not already present
    // We insert them at a safe location
    if (!repsEmailFound || !repNumberFound) {
      const repDetails = [];
      if (!repNumberFound) {
        repDetails.push({
          type: "Control",
          scope: "#/properties/rep_number",
          label: "Rep Number",
          options: { readOnly: true }
        });
      }
      if (!repsEmailFound) {
        repDetails.push({
          type: "Control",
          scope: "#/properties/reps_email",
          label: "Reps Email",
          options: { readOnly: true }
        });
      }

      // Safe injection: 
      // 1. If inside a Categorization, add to the first Category
      // 2. If it's a Layout, add to its elements
      // If it's a Categorization, add to the first tab's elements if possible
      if (uiSchemaCopy.type === "Categorization" && uiSchemaCopy.elements?.[0]?.elements) {
        uiSchemaCopy.elements[0].elements.unshift(...repDetails);
      } else {
        uiSchemaCopy.elements.unshift(...repDetails);
      }
    }

    // Inject Stage if Update Mode and not found
    if (mode === "update" && !stageFound) {
      const stageControl = {
        type: "Control",
        scope: "#/properties/stage",
        label: "Status"
      };

      if (uiSchemaCopy.type === "Categorization" && uiSchemaCopy.elements?.[0]?.elements) {
        // Find a good spot in the first tab or just unshift
        uiSchemaCopy.elements[0].elements.unshift(stageControl);
      } else {
        uiSchemaCopy.elements.unshift(stageControl);
      }
    }

    // Keep them in JSON schema to ensure they are tracked
    if (schemaCopy.properties) {
      ensureProperty('rep_number');
      ensureProperty('reps_email');
      ensureProperty('rep_email');
      ensureProperty('email');
    }

    if (hasNoCompletedFiles) {
      const removeCompletedDateInsideJobItems = (elements, insideJobItems = false) => {
        if (!elements) return [];

        return elements
          .map((el) => {
            if (el.scope === "#/properties/job_items" && el.options?.detail?.elements) {
              el.options.detail.elements = removeCompletedDateInsideJobItems(
                el.options.detail.elements,
                true
              );
            }

            if (el.elements) {
              el.elements = removeCompletedDateInsideJobItems(el.elements, insideJobItems);
            }

            return el;
          })
          .filter((el) => {
            if (insideJobItems && el.type === "Completed Date Label") {
              return false;
            }
            return true;
          });
      };

      uiSchemaCopy.elements = removeCompletedDateInsideJobItems(uiSchemaCopy.elements);
    }

    const isSuperAdmin = userRole === SUPER_ADMIN;
    
    // Roles that are allowed to edit "Sent Art to Customer" and "Customer Email"
    const canEditArtFields = [
      COMPANY_USER, 
      COMPANY_MANAGER
    ].includes(userRole);

    if (isAddnectarUser) {
      const remarksControl = {
        type: "Control",
        scope: "#/properties/remarks",
        label: "Remarks",
        options: {
          multi: true
        }
      };

      let remarksInserted = false;
      const insertRemarks = (elements) => {
        if (!elements) return false;
        for (let i = 0; i < elements.length; i++) {
          const el = elements[i];
          if (!el) continue;

          if (el.scope === "#/properties/instruction" || el.scope === "#/properties/instructions") {
            elements.splice(i + 1, 0, remarksControl);
            remarksInserted = true;
            return true;
          }

          if (el.elements && insertRemarks(el.elements)) return true;
          if (el.options && el.options.detail && Array.isArray(el.options.detail.elements) && insertRemarks(el.options.detail.elements)) return true;
        }
        return false;
      };

      insertRemarks(uiSchemaCopy.elements);
      if (!remarksInserted) {
        uiSchemaCopy.elements.push(remarksControl);
      }
    }

    const applyRoleBasedReadOnly = (layout) => {
      if (!layout) return;
      if (layout.type === 'Control') {
        const stageScope = "#/properties/stage";
        
        const propName = layout.scope ? layout.scope.replace("#/properties/", "") : "";
        const lowerPropName = propName.toLowerCase();

        const isUserRequestedExempt = 
          lowerPropName === 'segment#' || 
          lowerPropName === 'segment' || 
          lowerPropName === 'segment_number' || 
          lowerPropName === 'segment_no' || 
          lowerPropName === 'segment #' || 
          lowerPropName === 'campaign' || 
          lowerPropName === 'compaign_name' || 
          lowerPropName === 'customer_name' || 
          lowerPropName === 'customer name' || 
          lowerPropName === 'quotes' || 
          lowerPropName === 'quote#' || 
          lowerPropName === 'quote_number' ||
          lowerPropName === 'quote_#' ||
          lowerPropName === 'quote_no' ||
          lowerPropName === 'quote #' ||
          lowerPropName === 'customer#' || 
          lowerPropName === 'customer_no' ||
          lowerPropName === 'customer_number' || 
          lowerPropName === 'customer #' || 
          lowerPropName === 'logo_name' || 
          lowerPropName === 'logo name' || 
          lowerPropName === 'job_flag' ||
          lowerPropName === 'job flag';

        const isExempt = 
          layout.scope === stageScope || 
          layout.scope === "#/properties/job_items" ||
          layout.scope === "#/properties/remarks" ||
          isUserRequestedExempt ||
          (canEditArtFields && (layout.scope === "#/properties/send_art_to_customer" || layout.scope === "#/properties/customer_email"));

        if (!isExempt) {
          if (!layout.options) layout.options = {};
          layout.options.readOnly = true;
        }
      }
      if (layout.elements) {
        layout.elements.forEach(applyRoleBasedReadOnly);
      }
      if (layout.options?.detail?.elements) {
        layout.options.detail.elements.forEach(applyRoleBasedReadOnly);
      }
    };

    if (mode === "update" && !isSuperAdmin) {
      applyRoleBasedReadOnly(uiSchemaCopy);
    }

    return { schema: schemaCopy, uiSchema: uiSchemaCopy };
  }, [
    stagesStr,
    mode,
    hasNoCompletedFiles,
    rawSchema,
    rawUiSchema,
    company_process_stage
  ]); // Removed 'job_form' object dependency, replaced with stable rawSchema/rawUiSchema refs



  const jobDataRef = useRef(job_data);
  const formDataRef = useRef(formData);

  useEffect(() => {
    jobDataRef.current = job_data;
    formDataRef.current = formData;
  });

  // STABILIZE AND CHECK EQUALITY
  const stableStringify = useCallback((obj) => {
    try {
      return JSON.stringify(obj, (key, value) => {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          return Object.keys(value).sort().reduce((sorted, k) => {
            sorted[k] = value[k];
            return sorted;
          }, {});
        }
        return value;
      });
    } catch (e) {
      return null;
    }
  }, []);

  const debouncedHandleJobForm = useMemo(
    () => debounce((newData) => {
      // Avoid unnecessary store updates while typing. If the new data equals the
      // existing job_data from props, skip the dispatch to prevent re-renders
      const newStr = stableStringify(newData);
      const oldStr = stableStringify(jobDataRef.current);
      if (newStr && newStr === oldStr) return;

      handleJobForm(newData);
    }, 1000), // increased delay to reduce update frequency while typing
    [handleJobForm, stableStringify]
  );

  useEffect(() => {
    return () => {
      debouncedHandleJobForm.cancel();
    };
  }, [debouncedHandleJobForm]);

  const handleFormChange = useCallback(({ data, errors }) => {
    // Normalize job_items
    const normalizedJobItems = Array.isArray(data.job_items)
      ? data.job_items.map((item) => ({
        ...item,
        __isNew: item?.__isNew === true,
        disabled: item?.disabled === true,
        id: ensureString(item?.id),
        item: ensureString(item?.item),
        line_id: ensureString(item?.line_id),
        product_color: ensureString(item?.product_color),
        imprint_color: ensureString(item?.imprint_color),
        pos_loc_placment: ensureString(item?.pos_loc_placment),
        imprint_method: ensureString(item?.imprint_method),
        imprint_instruction: ensureString(item?.imprint_instruction),
        vector_count: ensureString(item?.vector_count),
        complex_vector_count: ensureString(item?.complex_vector_count),
        job_type: ensureString(item?.job_type),
        complexity_level: ensureString(item?.complexity_level),
        standard_job_cost: ensureString(item?.standard_job_cost),
        complex_vector_cost: ensureString(item?.complex_vector_cost),
        total_cost: ensureString(item?.total_cost),
        cost: ensureString(item?.cost),
        no_of_revisions: ensureString(item?.no_of_revisions),
        revision_cost: ensureString(item?.revision_cost),
        ETA: ensureString(item?.ETA),
        comments: ensureString(item?.comments),
        completed_time: ensureString(item?.completed_time),
        submitted_file: Array.isArray(item?.submitted_file) ? item.submitted_file : [],
        completed_file: Array.isArray(item?.completed_file) ? item.completed_file : [],
        eps_file: Array.isArray(item?.eps_file) ? item.eps_file : [],
        logo_file: Array.isArray(item?.logo_file) ? item.logo_file : []
      }))
      : [];

    const repInfo = getFullRepInfo();

    const updatedData = {
      ...data,
      job_items: normalizedJobItems,
      number_of_lines: String(normalizedJobItems.filter(isValidJobItem).length),
      // In create mode or if empty, use populated rep information
      reps_email: (mode === "create" || !data.reps_email) ? (repInfo.reps_email || data.reps_email || '') : data.reps_email,
      rep_number: (mode === "create" || !data.rep_number) ? (repInfo.rep_number || data.rep_number || '') : data.rep_number
    };

    const newStr = stableStringify(updatedData);
    const lastStr = stableStringify(lastDataRef.current || formDataRef.current || formData);

    if (newStr && newStr === lastStr) {
      return;
    }

    // Update the ref synchronously BEFORE calling setFormData to catch any synchronous recursions from JSON Forms
    lastDataRef.current = updatedData;
    if (!isDirty.current) isDirty.current = true;

    setFormData(updatedData);
    setFormErrors(errors);
    debouncedHandleJobForm(updatedData);
  }, [mode, getFullRepInfo, debouncedHandleJobForm]);

  const handleTrimSubmitClick = () => {
    const form = document.getElementById('job-form') || document.querySelector('form');
    if (form) {
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")?.set;
      const nativeTextAreaValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value")?.set;

      const inputs = form.querySelectorAll('input:not([type="file"]), textarea');
      inputs.forEach(input => {
        if ((input.type === 'text' || input.type === 'number' || input.type === 'email' || input.tagName.toLowerCase() === 'textarea') && typeof input.value === 'string') {
          const trimmed = input.value.trim();
          if (input.value !== trimmed) {
            if (input.tagName.toLowerCase() === 'textarea') {
               if (nativeTextAreaValueSetter) nativeTextAreaValueSetter.call(input, trimmed);
            } else {
               if (nativeInputValueSetter) nativeInputValueSetter.call(input, trimmed);
            }
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }
      });
    }
  };

  return (
    <Box className='jobWrapper' sx={{ flex: 1, mr: 1 }}>
      <Box
        sx={{
          bgcolor: "#fff",
          px: 2,
          mt: 0,
          py: 1.5, // Standardized padding
          minHeight: '45px',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          borderBottom: '20px solid #FFF5F2',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {/* LEFT SIDE */}
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 600,
            color: 'black',
            cursor: 'pointer'
          }}
          onClick={() => navigate('/')}
        >
          {mode === "update"
            ? `Update Job / ${job_id}`
            : "Create Job"}
        </Typography>

        {/* RIGHT SIDE BUTTONS */}
        {/* {mode === "update" && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button
              variant="contained"
              type='submit'
              form="job-form"
              sx={{
                backgroundColor: '#ff6100',
                color: '#fff',
                textTransform: 'none',
                borderRadius: '5px',
                fontSize: '14px',
                px: 3,
                py: 0.75,
                '&:hover': {
                  backgroundColor: '#e55600'
                }
              }}
            >
              UPDATE
            </Button>
          </Box>
        )} */}
      </Box>
      <Box sx={{
        px: 2,
        py: 2,
        bgcolor: 'white',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        width: '100%',
        maxWidth: '100%'
      }}>
        {/* {mode === "update" && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "text.primary",
              }}
            >
              Job #: {job_id}
            </Typography>
          </Box>
        )} */}

        <ThemeProvider theme={theme}>
          <form
            id="job-form"
            onSubmit={mode === "update" ? handleUpdate : handleSubmit}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="error" sx={{ fontStyle: 'italic' }}>
                All Fields Marked with <span style={{ color: 'red' }}>*</span> are Mandatory
              </Typography>
            </Box>

            {mode === "update" && formData === null && (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}>
                <CircularProgress sx={{ color: '#ff6100' }} />
              </Box>
            )}



            {formData !== null && dynamicSchema !== null && (
              <>
                <JsonForms
                  schema={dynamicSchema.schema}
                  uischema={dynamicSchema.uiSchema}
                  data={formData}
                  renderers={renderers}
                  cells={materialCells}
                  onChange={handleFormChange}
                  validationMode={showErrors ? "ValidateAndShow" : "ValidateAndHide"}
                />
              </>
            )}

            <Box sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              mt: 5

            }}>
              <Button
                variant="outlined"
                disableElevation
                color="error"
                sx={{ mr: 2 }}
                onClick={handleCancel}
              >
                Exit</Button>
              <Button
                variant="contained"
                disableElevation
                type='submit'
                onClick={handleTrimSubmitClick}
                sx={{ backgroundColor: '#ff6100' }}
              >{mode === "update" ? "Update" : "Submit"}</Button>
            </Box>
          </form>

          <BrandLibraryModal
            open={openBrandLibrary}
            onClose={() => setOpenBrandLibrary(false)}
            onSelect={handleSelectFromLibrary}
            isPersonal={openBrandLibraryIsPersonal}
            initialSelected={
              openBrandLibraryTarget === 'logo_references'
                ? (formData?.logo_references?.map(l => l.file_path || l) || [])
                : (getNested(formData, openBrandLibraryTarget)?.map(f => {
                  let val = f;
                  if (f?.file) val = (f.file instanceof File) ? f.file.name : f.file;
                  if (val && typeof val === 'string') {
                    if (val.startsWith('http')) {
                      try { const urlObj = new URL(val); val = urlObj.pathname; } catch (e) { }
                    }
                    val = decodeURIComponent(val);
                    if (val.startsWith('/files/')) val = val.substring(7);
                    if (val.startsWith('/')) val = val.substring(1);
                  }
                  return val;
                }) || [])
            }
          />
          <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
              {snackbar.message}
            </Alert>
          </Snackbar>
        </ThemeProvider>
      </Box>
    </Box >
  )
}

export default JobForm;
